module.exports = "<div class=\"loading-block\">\n    <p><ng-content></ng-content></p>\n    <span class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/progress-spinner/progress-spinner.component.html
// module id = 856
// module chunks = 0